import template from './sw-cms-preview-acris-blog-author-date.html.twig';
import './sw-cms-preview-acris-blog-author-date.scss';

const { Component } = Shopware;

Component.register('sw-cms-preview-acris-blog-author-date', {
    template
});
